import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Divider, message } from "antd";
import baseActions from "../actions";
import {
  DASHBOARDS,
  VIEW_LAYOUTS,
  VISUALISATIONS,
  VISUALISATION_DATA,
  GLOBAL_FILTERS,
  PERSIST_PARAMS,
  EVENT_PLANNING_PEAK_DAYS,
  INBOUND_VOLUME,
  USER_INFO,
  EVENT_PLANNING_SCENARIOS,
  EVENT_PLANNING_USER_SELECTED_SCENARIOS,
  EVENT_PLANNING_VOLUME_BY_WEEK,
  EVENT_PLANNING_PICK_VOLUME,
  EVENT_PLANNING_EQUIPMENT,
  EVENT_PLANNING_RESOURCE_PLAN,
  EVENT_PLANNING_RECRUITMENT_PLAN,
  EVENT_PLANNING_RESERVE_CAPACITY,
  EVENT_PLANNING_PEAK_DAYS_ORDER,
  EVENT_PLANNING_PICK_PLAN,
  EVENT_PLANNING_FLOOR_CAPACITY,
} from "../plannerConfig";
import PageWithTopbar from "../components/PageWithTopbar";
import Dashboard from "../components/Dashboard";
import WeekDayPicker from "../components/WeekDayPicker";
import {
  generateRouteParams,
  updateLink,
  getSetSequence,
  getFilters,
} from "../helpers";
import { GeneralFilter, mapGlobalFilterKeysToObj } from "../components/Filters";
import { ShowAppliedFilter } from "../components/Filters/ShowAppliedFilter";
import { getParsedVisualisationsAsObject } from "../selectors/dashboard";
import { DEPRECATED_DASHBOARD_FILTERS } from "../constants/text.constants";
import MultiWeekPlannerComponent from "../components/MultiWeekPlanner";
import LoadSpinnerOverlay from "../components/LoadSpinner";

const mapStateToProps = (state) => ({
  [EVENT_PLANNING_PEAK_DAYS]: state[EVENT_PLANNING_PEAK_DAYS],
  [INBOUND_VOLUME]: state[INBOUND_VOLUME],
  [USER_INFO]: state[USER_INFO],
  [EVENT_PLANNING_SCENARIOS]: state[EVENT_PLANNING_SCENARIOS],
  [EVENT_PLANNING_USER_SELECTED_SCENARIOS]:
    state[EVENT_PLANNING_USER_SELECTED_SCENARIOS],
  [EVENT_PLANNING_VOLUME_BY_WEEK]: state[EVENT_PLANNING_VOLUME_BY_WEEK],
  [EVENT_PLANNING_PICK_VOLUME]: state[EVENT_PLANNING_PICK_VOLUME],
  [EVENT_PLANNING_EQUIPMENT]: state[EVENT_PLANNING_EQUIPMENT],
  [EVENT_PLANNING_RESOURCE_PLAN]: state[EVENT_PLANNING_RESOURCE_PLAN],
  [EVENT_PLANNING_RECRUITMENT_PLAN]: state[EVENT_PLANNING_RECRUITMENT_PLAN],
  [EVENT_PLANNING_RESERVE_CAPACITY]: state[EVENT_PLANNING_RESERVE_CAPACITY],
  [EVENT_PLANNING_PEAK_DAYS_ORDER]: state[EVENT_PLANNING_PEAK_DAYS_ORDER],
  [EVENT_PLANNING_PICK_PLAN]: state[EVENT_PLANNING_PICK_PLAN],
  [EVENT_PLANNING_FLOOR_CAPACITY]: state[EVENT_PLANNING_FLOOR_CAPACITY],
});

const mapDispatchToProps = {
  get: baseActions.get,
  put: baseActions.put,
  post: baseActions.post,
  apiDelete: baseActions.delete,
  set: baseActions.set,
};

export class MultiWeekPlanner extends Component {
  componentDidMount() {
    const { get } = this.props;
    get([EVENT_PLANNING_USER_SELECTED_SCENARIOS]);
  }

  componentDidUpdate() {}

  render() {
    const store = {
      [EVENT_PLANNING_PEAK_DAYS]: this.props[EVENT_PLANNING_PEAK_DAYS],
      [INBOUND_VOLUME]: this.props[INBOUND_VOLUME],
      [USER_INFO]: this.props[USER_INFO],
      [EVENT_PLANNING_SCENARIOS]: this.props[EVENT_PLANNING_SCENARIOS],
      [EVENT_PLANNING_USER_SELECTED_SCENARIOS]: this.props[
        EVENT_PLANNING_USER_SELECTED_SCENARIOS
      ],
      [EVENT_PLANNING_VOLUME_BY_WEEK]: this.props[
        EVENT_PLANNING_VOLUME_BY_WEEK
      ],
      [EVENT_PLANNING_PICK_VOLUME]: this.props[EVENT_PLANNING_PICK_VOLUME],
      [EVENT_PLANNING_EQUIPMENT]: this.props[EVENT_PLANNING_EQUIPMENT],
      [EVENT_PLANNING_RESOURCE_PLAN]: this.props[EVENT_PLANNING_RESOURCE_PLAN],
      [EVENT_PLANNING_RECRUITMENT_PLAN]: this.props[
        EVENT_PLANNING_RECRUITMENT_PLAN
      ],
      [EVENT_PLANNING_RESERVE_CAPACITY]: this.props[
        EVENT_PLANNING_RESERVE_CAPACITY
      ],
      [EVENT_PLANNING_PEAK_DAYS_ORDER]: this.props[
        EVENT_PLANNING_PEAK_DAYS_ORDER
      ],
      [EVENT_PLANNING_PICK_PLAN]: this.props[EVENT_PLANNING_PICK_PLAN],
      [EVENT_PLANNING_FLOOR_CAPACITY]: this.props[
        EVENT_PLANNING_FLOOR_CAPACITY
      ],
    };

    const api = {
      get: this.props.get,
      post: this.props.post,
    };

    //scenarioPreConfig is the previously selected scenarios from the scenario selection modal
    //it gets sent after you press go
    const scenarioConfigData =
      store[EVENT_PLANNING_USER_SELECTED_SCENARIOS].data;
    const scenarioPreConfigLoading =
      store[EVENT_PLANNING_USER_SELECTED_SCENARIOS].loadingQueue.length;

    if (scenarioPreConfigLoading || !scenarioConfigData.length) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <LoadSpinnerOverlay text="Loading..." spinning={true} />
        </div>
      );
    }

    const initialStartDate = moment(Date.now());
    const initialEndDate = moment(initialStartDate).add(4, "weeks");

    const { userScenarios, filterData } = scenarioConfigData[0];
    const { fromDate, toDate } = userScenarios;

    const parseDate = (date) => {
      return moment(date);
    };

    return (
      <MultiWeekPlannerComponent
        api={api}
        store={store}
        scenarioPreConfig={userScenarios}
        fromDate={parseDate(fromDate) || initialStartDate}
        toDate={parseDate(toDate) || initialEndDate}
        filterData={filterData}
        {...this.props}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultiWeekPlanner);
